import { AppState } from '../reducers';
import { SettingPersistence } from './settings.persistence.reducer';

export const settingsPersistenceSelector = (state: AppState): SettingPersistence =>
  state.settingsPersistence.persistenceState;

export const wasSettingsStateMissingSelector = (state: AppState): boolean =>
  state.settingsPersistence.wasSettingsStateMissing;
